module.exports = __webpack_public_path__ + "img/grunge.9c44bdf0.webp";